// Mirrors max-height on .lbv2__member-search-dropdown in leaderboard_v2.sass.
export const SEARCH_DROPDOWN_MAX_HEIGHT = 480

// Matches lbv2-star-pop in leaderboard_v2.sass.
export const STAR_PULSE_MS = 180

export const VIEW_MODES = Object.freeze({
  WEB: 'web',
  LANDSCAPE: 'landscape',
  MOBILE: 'mobile',
});

export const VIEW_MODE_BREAKPOINTS = Object.freeze({
  LANDSCAPE_MAX_WIDTH: 768,
  MOBILE_MAX_WIDTH: 480,
  // The narrowest phones: below this a leaderboard row carries two data
  // columns, live round or not (useNarrowMobile, and the matching
  // `@media (max-width: 319px)` rules in leaderboard_v2_mobile.sass).
  NARROW_MOBILE_MAX_WIDTH: 319,
  // A phone on its side, identified by its short edge rather than its width:
  // modern iPhones are 844-956px wide in landscape, well past
  // LANDSCAPE_MAX_WIDTH, so a width test alone reads them as web. Heights stay
  // ~390-440px, while a landscape tablet is 768px+ and a laptop taller still.
  PHONE_MAX_HEIGHT: 480,
});

// Ruby↔JS contract: values produced by
// LeaderboardV2::InitialStateBuilderService (MANAGER_SITE_CONTEXT) — keep in sync.
export const SITE_CONTEXTS = Object.freeze({
  MANAGER_SITE: 'manager-site',
});

// JS↔CSS contract: PORTAL is the portal-generated theming rule
// (website_b/website_generate_color.sass), absent on the manager site;
// DEFAULT is the lbv2-owned fallback styled in leaderboard_v2/*.sass.
export const THEMED_TEXT_CLASSES = Object.freeze({
  DEFAULT: 'default-themed-text',
  PORTAL: 'themed-text',
});
